import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Slider from "react-slick";
import { AiFillDollarCircle } from "react-icons/ai";
import { BsFillMortarboardFill } from "react-icons/bs";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";

const Program = () => {

  const listProgram = [
    { name:"BA Hotel & Hospitality Management", desc:"Cocok buat kamu yang mau jadi hotel manager, event leader, atau hospitality pro level internasional.", img:"assets/images/program1.webp", degree:"Bachelor (S1)", tuition:"CHF 38,600 - 40,500 total (3 tahun)" },
    { name:"BA Culinary Arts / Pastry & Bakery", desc:"Belajar teknik kuliner Swiss + kreativitas pastry di dapur profesional.", img:"assets/images/program2.webp", degree:"Bachelor (S1)", tuition:"mirip dengan program BA lainnya" },
    { name:"Postgraduate Diploma in Business & Hospitality", desc:"Cocok buat yang sudah lulus S1 & mau naik level skill manajerial cepat.", img:"assets/images/program3.webp", degree:"Postgraduate Diploma", tuition:"CHF 38,600 (1 tahun)" },
    { name:"MSc / MBA International Hospitality & Business", desc:"Level lanjutan buat jadi leader di global hospitality & bisnis.", img:"assets/images/program4.webp", degree:"Master / Dual degree", tuition:"CHF 40,600 - 57,000" },
  ]

  const NextArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow next" onClick={onClick}>
        <FaChevronRight size={24} />
      </div>
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow prev" onClick={onClick}>
        <FaChevronLeft size={24} />
      </div>
    );
  };

  const settings = {
    className: "center",
    dots: true,
    infinite: true,
    speed: 500,
    
    centerMode: false,
    centerPadding: "0px",
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,     
    responsive: [   
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },        
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: "35px",
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },            
    ],    
  };

  return (
    <>
      <section className="section" id="program">
        <Container>
          <Row className="">
            <Col className="">
              <div className="slide-wrapper">
                <h1 className="mb-3"><b>Program Studi Unggulan</b></h1>
                  <Slider {...settings}>
                    {listProgram.map((item, id) =>(
                      <Card key={id} className=''>
                        <img
                          alt={item.name}
                          src={item.img}
                          className="img-fluid"
                        />
                        <CardBody>
                          <div className="row">
                            <div className="col-1">
                            <BsFillMortarboardFill color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.name}</p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-1">
                            <AiFillDollarCircle color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.tuition}</p>
                            </div>
                          </div>     
                          <div className="mt-3">{item.desc}</div>                 
                        </CardBody>
                      </Card>
                    ))}
                  </Slider>
                <p className="note">*Biaya adalah estimasi per tahun/total biaya studi dalam Swiss Franc (CHF). Biaya bisa berubah tergantung pilihan program tambahan, akomodasi, dan opsi upgrade kamar.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Program;